import React, { memo } from 'react'

import ReactPlayer from 'react-player'
import useWindowDimensions from '../../../hooks/useWindowDimensions';

function Video({ videoPlaying, video, onProgress, playerRef, video_url, source }) {

   const { width } = useWindowDimensions();
   
   return (
      <>
         {
            video_url !== null ?
               <ReactPlayer
                  ref={playerRef}
                  width={width < 1200 ? '100%' : '640px'}
                  height={width < 1200 ? '500px' : '360px'}
                  className='video'
                  style={{ marginRight: width > 1200 ? '1rem' : '' }}
                  url={source}
                  // url={URL.createObjectURL(video)}
                  controls={true}
                  onProgress={onProgress}
                  playing={videoPlaying}
               /> : video ?
                  <ReactPlayer
                     ref={playerRef}
                     width={width < 1200 ? '100%' : '640px'}
                     height={width < 1200 ? '500px' : '360px'}
                     className='video'
                     style={{ marginRight: width > 1200 ? '1rem' : '' }}
                     url={source}
                     // url={URL.createObjectURL(video)}
                     controls={true}
                     onProgress={onProgress}
                     playing={videoPlaying}
                  />
                  : <></>
         }
      </>
   )
}

export default memo(Video)
